import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {WidgetLoadedEvent} from "../models/events/widget.loaded-event";
import {WidgetAnalyticsEventHandler} from "../../infrastructure/handlers/widget-analytics-event-handler";

export class WidgetLoadedEventHandler extends WidgetAnalyticsEventHandler {
  type: String;
  eventType: WidgetLoadedEvent

  static injectables = [AnalyticsService];

  async action(params) {
    this.eventType = WidgetLoadedEvent;

    await super.action(params);
  }

  onRenderComplete() {
    const loadTime: Number = Date.now() - this.appStore.state.settings.bootstrapSettings.applicationStartTime;
    const isValidStartTime: Boolean = this.appStore.state.settings.bootstrapSettings.applicationStartTime > 0;
    const isWidget: Boolean = this.appStore.state.settings.isWidget;
    const widgetId: String = this.appStore.state.settings.bootstrapSettings.widgetId;
    const sendEvent: Boolean = isValidStartTime && isWidget;

    sendEvent && this.action({loadTime, widgetId})
  }
}
